const isReadOnly = (isEditor: boolean, action: string) => {
    if (isEditor) {
        return ((action === "edit" || action === "create" || action === "update") ? false : true)
    } else
        return true
}

export { isReadOnly }